import React from "react";
import Keycloak from "keycloak-js";
import { asyncNoop, falseFn } from "../utils.js";

export type KeycloakAuth = Pick<
  Keycloak,
  | "token"
  | "updateToken"
  | "login"
  | "logout"
  | "register"
  | "idTokenParsed"
  | "createRegisterUrl"
>;

export interface AuthContext {
  isReady: boolean;
  isAuthenticated: boolean;
  belongsToGroup: (groupName: string) => boolean;
  auth: KeycloakAuth;
}

export const AuthContext = React.createContext<AuthContext>({
  isReady: false,
  isAuthenticated: false,
  belongsToGroup: falseFn,
  auth: {
    token: undefined,
    updateToken: asyncNoop,
    login: asyncNoop,
    logout: asyncNoop,
    register: asyncNoop,
    createRegisterUrl: dummyCreateRegisterUrl,
    idTokenParsed: undefined,
  },
});

async function dummyCreateRegisterUrl() {
  return "";
}

/**
 * Checks the token's `groups` claim for the given group. The realm's
 * group-membership mapper has "full group path" turned off, so the claim
 * carries plain group names (`org-creator`); the requested group is matched
 * exactly, tolerating only a leading slash on either side.
 */
export function tokenBelongsToGroup(
  idTokenParsed: Keycloak["idTokenParsed"],
  groupPath: string
): boolean {
  const groups: unknown = idTokenParsed?.groups;
  if (!Array.isArray(groups)) {
    return false;
  }
  const normalize = (value: string) => value.replace(/^\//, "");
  const requested = normalize(groupPath);
  return groups.some(
    candidate =>
      typeof candidate === "string" && normalize(candidate) === requested
  );
}
